// Organization User Action Types
export const GET_ORG_USERS = "GET_ORG_USERS";
export const ADD_BULK_ORG_USER = "ADD_BULK_ORG_USER";
export const ADD_ORG_USER = "ADD_ORG_USER";
export const UPDATE_ORG_USER = "UPDATE_ORG_USER";
export const DELETE_ORG_USER = "DELETE_ORG_USER";
export const TOGGLE_ORG_USER_STATUS = "TOGGLE_ORG_USER_STATUS";

// Loading and Error States
export const SET_ORG_USER_LOADING = "SET_ORG_USER_LOADING";
export const SET_ORG_USER_ERROR = "SET_ORG_USER_ERROR";
export const CLEAR_ORG_USER_ERROR = "CLEAR_ORG_USER_ERROR";

// Selection
export const SELECT_ORG_USER = "SELECT_ORG_USER";
export const CLEAR_SELECTED_ORG_USER = "CLEAR_SELECTED_ORG_USER";

// Filter and Search
export const FILTER_ORG_USERS = "FILTER_ORG_USERS";
export const SEARCH_ORG_USERS = "SEARCH_ORG_USERS";
export const SET_ORG_USER_FILTER = "SET_ORG_USER_FILTER";

// Department and Role Management
export const GET_ORG_DEPARTMENTS = "GET_ORG_DEPARTMENTS";
export const ADD_ORG_DEPARTMENT = "ADD_ORG_DEPARTMENT";
export const UPDATE_ORG_DEPARTMENT = "UPDATE_ORG_DEPARTMENT";
export const DELETE_ORG_DEPARTMENT = "DELETE_ORG_DEPARTMENT";

export const GET_ORG_ROLES = "GET_ORG_ROLES";
export const ADD_ORG_ROLE = "ADD_ORG_ROLE";
export const UPDATE_ORG_ROLE = "UPDATE_ORG_ROLE";
export const DELETE_ORG_ROLE = "DELETE_ORG_ROLE";
